import cn from 'classnames';
import { TopShefBgIcon, TopShefShefHatIcon } from './Icons';

interface TopShefFlagProps extends React.HTMLAttributes<HTMLDivElement> {
  shadow?: boolean;
}

export const TopShefFlag = ({ shadow, className, ...props }: TopShefFlagProps) => (
  <div {...props} className={cn(className, { 'cursor-pointer': !!props.onClick })}>
    <div className='relative z-10 flex h-7 justify-center pl-2.5 pr-1'>
      {shadow && (
        <div
          className='absolute left-0 top-full size-0 border-solid'
          style={{
            borderWidth: '0 6px 8px 0',
            borderColor: `transparent #9E1C4C transparent transparent`,
          }}
        />
      )}

      <TopShefBgIcon className={cn('absolute bottom-0 left-0 right-0 top-0 -z-10', { 'rounded-bl-[2px]': !shadow })} />

      <div className='flex h-7 items-center'>
        <TopShefShefHatIcon className='-mt-0.5 mr-1 size-4 text-white' />
        <div className='text-xs font-bold uppercase tracking-wide text-white'>Top shef</div>
      </div>
    </div>
  </div>
);
